// ESPN team emblem(s) for a leg; totals show both teams.
export default function TeamLogo({ leg, size = 16 }) {
  const isTotal = (leg.bet_type || '').toLowerCase() === 'total';
  const logos = isTotal ? [leg.away_logo, leg.home_logo].filter(Boolean) : [leg.team_logo].filter(Boolean);
  if (!logos.length) return null;
  return (
    <span className="inline-flex shrink-0 items-center -space-x-1" data-testid={`team-logo-${leg.id}`}>
      {logos.map((src) => (
        <img key={src} src={src} alt="" width={size} height={size} loading="lazy"
          className="rounded-full bg-white/90 p-[1px] object-contain" style={{ width: size, height: size }}
          onError={(e) => { e.currentTarget.style.display = 'none'; }} />
      ))}
    </span>
  );
}

// Which team this leg is for (logo + abbreviation), shown on the right of each leg on multi-game tickets.
export const LegTeam = ({ leg, size = 18 }) => {
  if ((leg.bet_type || '').toLowerCase() === 'total' || !leg.team_logo) return null;
  const abbr = leg.team_logo === leg.home_logo ? leg.home_abbr : leg.team_logo === leg.away_logo ? leg.away_abbr : null;
  return (
    <span className="ml-auto inline-flex shrink-0 items-center gap-0.5" data-testid={`leg-team-${leg.id}`}>
      <img src={leg.team_logo} alt="" width={size} height={size} loading="lazy" className="rounded-full bg-white/90 p-[1px] object-contain" style={{ width: size, height: size }} />
      {abbr && <span className="text-[9px] font-black text-white/90">{abbr}</span>}
    </span>
  );
};

// More than two teams on the ticket = legs from more than one game.
export const multiTeam = (ticket) => new Set((ticket.legs || []).map((l) => l.espn_event_id || l.selection)).size > 1;
